.checkboxWrapper {
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 2px;

  & input {
    opacity: 0;
    display: block;
    height: 0;
    width: 0;
    position: absolute;
    overflow: hidden;
  }

  & .checkbox {
    display: inline-block;
    border: 1px solid var(--color-text);
    border-radius: 4px;
    width: 20px;
    height: 20px;
    position: relative;
    outline-offset: -1px;
    background: var(--color-bg-white);
    transition: background 300ms;
    flex-shrink: 0;

    &:after {
      font-family: var(--serif);
      content: "\2714";
      position: absolute;
      color: #fff;
      width: 100%;
      height: 100%;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding-left: 1px;
      padding-bottom: 2px;
      opacity: 0;
      transform: scale(0);
      transition:
        opacity 300ms,
        transform 300ms;
    }
  }

  & input:checked ~ .checkbox {
    background: var(--color-accent);
    border-color: var(--color-accent);

    &:after {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:hover {
    background: var(--color-bg-white);

    input:checked ~ .checkbox {
      background: var(--color-accent-hover);
      border-color: var(--color-accent-hover);
    }
  }

  &:has(:focus-visible) {
    outline: 5px auto -webkit-focus-ring-color;
  }
}
